/*
 * Copyright (c) 2020.
 * Simon
 */

import React, {Component} from 'react';
import {Modal, ModalBody, ModalHeader} from 'reactstrap';
import i18n from 'i18next';
import {connect} from "react-redux";
import FanpageHearsTable from "./FanpageHearsTable";
import FanpageHearsTabs from "./FanpageHearsTabs";

class FanpageHearsModal extends Component {
    constructor(props) {
        super(props);

        FanpageHearsModal.__singletonRef = this;

        this.state = {
            isOpen: false,
            backdrop: true,
            scrollable: true,
            keyboard: true,
            fanpageId: 0,
        };
    }

    actor() {
        return 'FanpageHearsModal';
    }

    toggle = () => {
        this.setState({
            isOpen: !this.state.isOpen,
        });
    };

    static showFanpageHear(fanpageId, hearId = undefined, hear = undefined) {
        FanpageHearsModal.__singletonRef._show(fanpageId, hearId, hear);
    }

    _show(fanpageId, hearId, hear) {
        this.setState({
            isOpen: true,
            fanpageId: fanpageId,
            hearId: hearId,
            hear: hear,
        });
    }

    static chooseHearById(hearId, hear) {
        FanpageHearsModal.__singletonRef._chooseHearById(hearId, hear);
    }

    _chooseHearById(hearId, hear) {
        this.setState({hearId: hearId, hear: hear});
    }

    render() {
        return (
            <span>
                <Modal
                    onEnter={this.onEnter}
                    toggle={this.toggle}
                    isOpen={this.state.isOpen}
                    size='lg'
                    backdrop={this.state.backdrop}
                    keyboard={this.state.keyboard}
                >
                    <ModalHeader toggle={this.toggle}>
                        {i18n.t('Fanpage\'s Hear')}
                    </ModalHeader>
                    <ModalBody style={{minHeight: "500px"}}>
                        <div className="row">
                            <div className="col-sm-3" style={{marginBottom: "10px"}}>
                                <FanpageHearsTable hearsModal={this} fanpageId={this.state.fanpageId}/>
                            </div>
                            <div className="col-sm-9">
                                <FanpageHearsTabs
                                    fanpageId={this.state.fanpageId}
                                    hearId={this.state.hearId}
                                    hear={this.state.hear}
                                />
                            </div>
                        </div>
                    </ModalBody>
                </Modal>
            </span>
        );
    }
}

const mapStateToProps = (state) => {
    return {
        fanpageHearsModalReducer: state.FanpageHearsModalReducer
    }
};


export default connect(mapStateToProps, {})(FanpageHearsModal);
